<template>
<div class="bg-base-200 collapse collapse-arrow bg-white border shadow">
  <input type="checkbox" ref="collapse" class="peer" />
  
  <div
    class="collapse-title text-lg">
    <div class="flex items-center">
      <Icon :icon="props.icon" class="mr-2" width="23px"/> {{ props.title }}
    </div>
    
   <div v-if="subtitle!=undefined" style="font-size:13px">
      {{ subtitle }}
    </div>
  </div>
  <div
    class="collapse-content">
    <slot></slot>
  </div>
</div>
</template>

<script setup>
import { defineProps, onMounted, watch,ref } from 'vue'
  import { useSidebar } from "@/store/sidebar";
  import { Icon } from "@iconify/vue/dist/offline";
  import MenuAccordion from "./MenuAccordion.vue";
  import { Tooltip } from 'equal-vue'


  const collapse = ref(null);

  const props = defineProps(['title','subtitle','collapsed',"icon"]);

  onMounted(function(){
    if(props.collapsed!=null){
      console.log("dd");
      collapse.value.checked=true;   
    }
  });

  watch(props.collapsed,function(){
    if(props.collapsed!=null){
      console.log("dd");
      collapse.value.checked=true;   
   
    }
  });
</script>
